import React, { useState } from 'react';
import { Stethoscope, Save, FileText, CheckCircle } from 'lucide-react';

export const TherapistSOAPModule: React.FC = () => {
  const [subjective, setSubjective] = useState('Student arrived attentive and engaged. Parent reported positive practice with AAC board over weekend.');
  const [objective, setObjective] = useState('Completed 45-minute articulation trial on /r/ sounds. 18 out of 20 correct trials achieved (90%).');
  const [assessment, setAssessment] = useState('Demonstrates marked improvement in vocalic resonance. Ready to advance to sentence-level drills.');
  const [plan, setPlan] = useState('Continue bi-weekly 45-min sessions. Introduce multi-syllabic targets next session.');
  const [saved, setSaved] = useState(false);

  const handleSaveSoap = (e: React.FormEvent) => {
    e.preventDefault();
    setSaved(true);
    setTimeout(() => setSaved(false), 3000);
  };

  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm space-y-6">
      <div className="flex items-center justify-between border-b border-slate-100 pb-4">
        <div>
          <span className="px-2.5 py-0.5 bg-sky-100 text-sky-800 text-[10px] font-bold rounded-full uppercase tracking-wider">
            WebPT & CentralReach Benchmark
          </span>
          <h2 className="text-2xl font-bold text-slate-900 mt-1">Therapist Workspace & SOAP Notes</h2>
          <p className="text-xs text-slate-500">Standardized Subjective, Objective, Assessment, Plan progress documentation</p>
        </div>
      </div>

      <form onSubmit={handleSaveSoap} className="space-y-4">
        {saved && (
          <div className="p-3 bg-emerald-50 border border-emerald-200 text-emerald-800 text-xs font-bold rounded-lg flex items-center gap-2">
            <CheckCircle className="w-4 h-4 text-emerald-600" />
            SOAP Note saved & synced to student health record
          </div>
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-bold text-slate-700 mb-1">Subjective (S)</label>
            <textarea
              rows={3}
              value={subjective}
              onChange={(e) => setSubjective(e.target.value)}
              className="w-full p-2.5 border border-slate-300 rounded-xl text-xs focus:ring-2 focus:ring-sky-500 focus:outline-none"
            />
          </div>

          <div>
            <label className="block text-xs font-bold text-slate-700 mb-1">Objective (O)</label>
            <textarea
              rows={3}
              value={objective}
              onChange={(e) => setObjective(e.target.value)}
              className="w-full p-2.5 border border-slate-300 rounded-xl text-xs focus:ring-2 focus:ring-sky-500 focus:outline-none"
            />
          </div>

          <div>
            <label className="block text-xs font-bold text-slate-700 mb-1">Assessment (A)</label>
            <textarea
              rows={3}
              value={assessment}
              onChange={(e) => setAssessment(e.target.value)}
              className="w-full p-2.5 border border-slate-300 rounded-xl text-xs focus:ring-2 focus:ring-sky-500 focus:outline-none"
            />
          </div>

          <div>
            <label className="block text-xs font-bold text-slate-700 mb-1">Plan (P)</label>
            <textarea
              rows={3}
              value={plan}
              onChange={(e) => setPlan(e.target.value)}
              className="w-full p-2.5 border border-slate-300 rounded-xl text-xs focus:ring-2 focus:ring-sky-500 focus:outline-none"
            />
          </div>
        </div>

        <button
          type="submit"
          className="px-6 py-2.5 bg-sky-600 hover:bg-sky-700 text-white font-bold rounded-xl text-xs shadow transition flex items-center gap-2"
        >
          <Save className="w-4 h-4" />
          Save & Sign SOAP Clinical Note
        </button>
      </form>
    </div>
  );
};
